/* This example requires Tailwind CSS v2.0+ */
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeaderWithBackgroundImageAndOverlappingCardsData on StrapiComponentHeaderWithBackgroundImageAndOverlappingCards {
    title
    topic
    description
    cards {
      title
      topic
      description
      icon {
        ...StrapiMediaSubquery
      }
      callToAction {
        ...StrapiSharedLink
      }
    }
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function WithBackgroundImageAndOverlappingCards({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      {/* Header */}
      <div className="relative bg-background-dark-gray pb-32">
        {data.image && (
          <div className="absolute inset-0">
            <MediaWrapper media={data.image} divClassName="w-full h-full" />
            {/* <div className="absolute inset-0 bg-background-gray-800 mix-blend-multiply" aria-hidden="true" /> */}
          </div>
        )}
        <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
          {data.topic && (
            <h3 className="text-3xl tracking-tight text-text-white md:text-4xl">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h1 className="text-4xl font-extrabold tracking-tight text-text-white md:text-5xl lg:text-6xl">
              <MarkdownWrapper text={data.title} />
            </h1>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-6 max-w-3xl text-xl text-text-secondary-light"
              replaceParagraph={false}
            />
          )}
        </div>
      </div>

      {/* Overlapping cards */}
      <section
        className="relative z-10 mx-auto -mt-32 max-w-7xl px-4 pb-32 sm:px-6 lg:px-8"
        aria-labelledby="contact-heading"
      >
        {/*
        <h2 className="sr-only" id="contact-heading">
          Contact us
        </h2>
        */}
        {Boolean(data.cards?.length) && (
          <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-0">
            {data.cards.map((card, index) => (
              <div
                key={index}
                className="flex flex-col rounded-2xl bg-background-white shadow-xl"
              >
                <div className="relative flex-1 px-6 pb-8 pt-16 md:px-8">
                  {card.icon && (
                    <div className="absolute top-0 inline-block -translate-y-1/2 transform rounded-xl bg-background-primary p-5 shadow-lg">
                      <MediaWrapper
                        media={card.icon}
                        objectFit="contain"
                        divClassName="h-6 w-6 text-text-white"
                      />
                    </div>
                  )}
                  {card.topic && (
                    <h4 className="font-medium text-text-secondary">
                      <MarkdownWrapper text={card.topic} />
                    </h4>
                  )}
                  {card.title && (
                    <h3 className="text-xl font-medium text-text-primary">
                      <MarkdownWrapper text={card.title} />
                    </h3>
                  )}
                  {card.description && (
                    <MarkdownWrapper
                      text={card.description}
                      markdownClassName="mt-4 text-base text-text-secondary"
                    />
                  )}
                </div>
                {card.callToAction?.link?.url &&
                  (card.callToAction?.overwriteTitle ||
                    card.callToAction?.link?.title) && (
                    <div className="rounded-bl-2xl rounded-br-2xl bg-background-off-white p-6 md:px-8">
                      <LinkWrapper
                        to={card.callToAction.link.url}
                        className="text-base font-medium text-text-primary-dark hover:text-text-primary"
                      >
                        {card.callToAction.overwriteTitle ||
                          card.callToAction.link.title}
                      </LinkWrapper>
                    </div>
                  )}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

WithBackgroundImageAndOverlappingCards.propTypes = {
  data: PropTypes.object,
};

export default WithBackgroundImageAndOverlappingCards;
